import { Pagination } from './pagination';
import { Role } from './role';
import { TeamRole } from './team';

export class User {
  id = 0;
  name = '';
  deleted_at?: string;
  email = '';
  password?: string;
  require_reset = false;
  history: any;
  roles: Role[] = [];
  teams: TeamRole[] = [];
  team_roles: any[] = [];
}

export class UserResponse {
  message = '';
  pagination = new Pagination();
  user = new User;
  users: User[] = [];
}
